export default __webpack_public_path__ + "static/media/AssociateMono-Light.40ee33f0.woff2";